export class client {

    id: string;
    managerId: string;
    createdDate: Date;
    modifiedDate: Date;
    Address: clientBasicInfo;
    isEnabled: boolean;

    constructor() {
        this.id = '0';
        this.Address = new clientBasicInfo();
        this.createdDate = new Date();
        this.modifiedDate = new Date();
        this.managerId = '';
        this.isEnabled = false;
    }
};

export class clientBasicInfo {

    res_address: string;
    res_name: string;
    user_rating: number;
    constructor() {
        this.res_address = '';
        this.res_name = '';
        this.user_rating = 0;
    }

}


// WEBPACK FOOTER //
// ./src/shared/client.ts